import { CompanyEditPage } from "@/pages/company-edit";
import { createFileRoute, useParams } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth_requeired/admin/companies/$id/")({
  component: () => {
    const { id } = useParams({ from: "/_auth_requeired/admin/companies/$id/" });

    return <CompanyEditPage companyId={Number(id)} isXmileSystemAdmin={true} />;
  },
});
